import { ContactTechnicalSupportLinks } from '@experiences/constants';
import type { IUiDialogHookCustomContent } from '@experiences/interfaces';
import {
    SpacingToken,
    UiStack,
    UiText,
} from '@experiences/ui-common';
import { useLocalizedLinks } from '@experiences/util';
import { makeStyles } from '@mui/styles';
import { ApButton } from '@uipath/portal-shell-react';
import React from 'react';
import { useIntl } from 'react-intl';

import { MIGRATION_ERROR_CODE_TO_I18N } from '../../../util/MigrationUtil';

const useStyles = makeStyles({
    root: {
        maxWidth: '456px',
        padding: '4px',
    },
});

// ts-unused-exports:disable-next-line
export interface MigrationNotAvailableDialogProps extends IUiDialogHookCustomContent {
    errorCode?: string;
    notAvailableReasonKey: string;
}

// ts-unused-exports:disable-next-line
export const MigrationNotAvailableDialog: React.FC<MigrationNotAvailableDialogProps> = ({
    closeDialog, errorCode, notAvailableReasonKey,
}) => {
    const classes = useStyles();
    const { formatMessage: translate } = useIntl();
    const getLocalizedLink = useLocalizedLinks();

    const i18nKey = errorCode ? MIGRATION_ERROR_CODE_TO_I18N[errorCode] : undefined;

    return (
        <UiStack
            className={classes.root}
            gap={SpacingToken.M}
            direction="column">
            <UiText>
                {i18nKey
                    ? translate({ id: i18nKey })
                    : translate({ id: notAvailableReasonKey })}
            </UiText>
            <UiText>
                {translate({ id: 'CLIENT_MIGRATION_NOT_AVAILABLE_REASON_2' })}
            </UiText>
            <UiStack
                direction="row"
                gap={SpacingToken.S}
                justify="end">
                <ApButton
                    variant="tertiary"
                    data-cy="cancel-button"
                    onClick={() => closeDialog()}
                    label={translate({ id: 'CLIENT_CANCEL' })}
                />
                <ApButton
                    variant="primary"
                    data-cy="file-ticket-button"
                    onClick={() => {
                        window.open(getLocalizedLink(ContactTechnicalSupportLinks)!, '_blank', 'noopener,noreferrer');
                        closeDialog();
                    }}
                    label={translate({ id: 'CLIENT_FILE_SUPPORT_TICKET' })}
                />
            </UiStack>
        </UiStack>
    );
};
